import { useEffect, useMemo, useState } from "react";
import { IHeaderTable } from "../../../../types/global";

export const useSalesItemListPdfHeader = () => {
  const [headers, setHeaders] = useState<IHeaderTable[]>([]);
  const columns = useMemo<IHeaderTable[]>(
    () => [
      {
        thaiLabel: "",
        width: 20,
        align: "left",
      },
      {
        thaiLabel: "สินค้า",
        width: 193,
        align: "left",
      },
      {
        thaiLabel: "จำนวน",
        width: 56,
        align: "right",
      },
      {
        thaiLabel: "หน่วย",
        width: 56,
        align: "left",
      },
      {
        thaiLabel: "ราคา/หน่วย",
        width: 82.2,
        align: "right",
      },
      {
        thaiLabel: "ส่วนลด",
        width: 61.65,
        align: "right",
      },
      {
        thaiLabel: "จำนวนเงิน",
        width: 82.2,
        align: "right",
      },
      {
        thaiLabel: "",
        width: 40,
      },
    ],
    []
  );
  useEffect(() => {
    setHeaders(columns);
  }, [columns]);

  return headers;
};
